import React, { useRef } from 'react';
import { Container, Nav, Navbar } from "react-bootstrap";
import { FaUser } from "react-icons/fa6";
import { GoHome } from "react-icons/go";
import { HiClipboardDocumentCheck } from "react-icons/hi2";
import { IoDocument } from "react-icons/io5";
import { MdOutlineGridView, MdOutlineShareLocation } from "react-icons/md";
import { useSelector } from 'react-redux';
import mainLogo from "../../images/ajcl_logo.png";
import userAvatar from "../../images/user_avatar.png";
import { fileBaseUrl, getUserDetail } from '../../Utils/Helper';
import './Header.css';
import MobileSidebar from './MobileSidebar';

const Header = () => {
    const navbarRef = useRef();

    const { getUserInfo } = useSelector((state) => state.getEditProfile);

    const NavHandler = () => {
        if (navbarRef.current.style.width === "100%") navbarRef.current.style.width = "0%";
        else navbarRef.current.style.width = "100%";
    };

    const dashboardSidebar = [
        {
            path: "/dashboard",
            icon: <GoHome />,
            title: "Dashboard",
        },
        // Only show All Tenders for super-admin
        ...(getUserDetail()?.role === 'super-admin' ? [{
            path: "/dashboard/all-tenders",
            icon: <MdOutlineGridView />,
            title: "All Tenders",
        }] : []),
        {
            path: "/dashboard/assigned-tenders",
            icon: <HiClipboardDocumentCheck />,
            title: "Assigned Tenders",
        },
        {
            path: "/dashboard/interested-tenders",
            icon: <IoDocument />,
            title: "Interested Tenders",
        },
        {
            path: "/dashboard/applied-tenders",
            icon: <MdOutlineShareLocation />,
            title: "Applied Tenders",
        },
        {
            path: "/dashboard/profile",
            icon: <FaUser />,
            title: "Profile",
        },
    ];

    return (
        <div>
            <MobileSidebar
                navbarRef={navbarRef}
                NavHandler={NavHandler}
                sideBarItems={dashboardSidebar}
            />
            <Navbar className="main_header" collapseOnSelect expand="lg">
                <Container fluid>
                    <Navbar.Brand> <img src={mainLogo} alt='' /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={NavHandler} />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-auto">
                            <div className='user_detail'>
                                <div>
                                    <p>Greetings,</p>
                                    {
                                        getUserInfo && getUserInfo?.data?.user_name ?
                                            <h4>{getUserInfo?.data?.user_name}</h4>
                                            :
                                            <h6>{getUserDetail()?.user_name}</h6>
                                    }
                                </div>
                                <div className='user_img'>
                                    {
                                        getUserInfo && getUserInfo?.data?.image ?
                                            <img src={`${fileBaseUrl}/${getUserInfo?.data?.image}`} alt='' />
                                            :
                                            <img src={getUserDetail()?.image ? `${fileBaseUrl}/${getUserDetail()?.image}` : userAvatar} alt='' />
                                    }
                                </div>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}
export default Header;